import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const useInviteDependent = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useNotification();

  return useMutation({
    mutationFn: data =>
      api.post('/api/account_settings/invite_dependent', data),
    onSuccess: response => {
      // Update cache with the settings returned from the server
      if (response.data?.settings) {
        queryClient.setQueryData(['accountSettings'], response.data.settings);
      }
      showSuccess({
        title: 'Success',
        content: 'Invitation sent successfully!',
      });
    },
    onError: error => {
      showError({
        title: 'Error',
        content: error.response?.data?.errors || 'Failed to send invitation',
      });
    },
  });
};

export const useResendDependentInvite = () => {
  const { showSuccess, showError } = useNotification();

  return useMutation({
    mutationFn: id =>
      api.post('/api/account_settings/resend_dependent_invite', { id }),
    onSuccess: () => {
      showSuccess({
        title: 'Success',
        content: 'Invitation resent successfully!',
      });
    },
    onError: error => {
      showError({
        title: 'Error',
        content: error.response?.data?.errors || 'Failed to resend invitation',
      });
    },
  });
};

export default useInviteDependent;
